const FOCUSABLE_SELECTOR = 'a:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"])';

const isElementVisible = element => {
  const style = window.getComputedStyle(element);
  return (
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    element.offsetParent !== null
  );
};

const getFocusableElements = container => {
  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    isElementVisible
  );
};

const navigateWithinOrders = (activeElement, e) => {
  const ordersTable = document.querySelector(".MuiTableBody-root");
  const mobileCardsContainer = document.querySelector(".mobile-cards-container");
  const ordersContainer = ordersTable || mobileCardsContainer;
  
  if (!ordersContainer || !ordersContainer.contains(activeElement)) return;

  const allViewDetailsLinks = Array.from(
    ordersContainer.querySelectorAll('a')
  ).filter(isElementVisible);

  if (allViewDetailsLinks.length === 0) return;

  const currentIndex = allViewDetailsLinks.indexOf(activeElement);
  if (currentIndex < 0) return;

  const isLastLink = currentIndex === allViewDetailsLinks.length - 1;

  if (isLastLink && !e.shiftKey) {
    e.preventDefault();
    
    const sideBarMenu = document.querySelector("#side-bar-menu");
    if (sideBarMenu) {
      const firstMenuItem = sideBarMenu.querySelector('.side-bar-item');
      if (firstMenuItem) {
        firstMenuItem.focus();
      }
    }
  }
};

const handleArrowKeyNavigation = event => {
  if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;

  const ordersTable = document.querySelector(".MuiTableBody-root");
  const mobileCardsContainer = document.querySelector(".mobile-cards-container");
  const ordersContainer = ordersTable || mobileCardsContainer;
  
  if (!ordersContainer) return;

  const activeElement = document.activeElement;
  if (!ordersContainer.contains(activeElement)) return;

  event.preventDefault();

  const allViewDetailsLinks = Array.from(
    ordersContainer.querySelectorAll('a')
  ).filter(isElementVisible);

  if (allViewDetailsLinks.length === 0) return;

  const currentIndex = allViewDetailsLinks.indexOf(activeElement);
  if (currentIndex < 0) return;

  const isGoingDown = event.key === "ArrowDown";
  const isGoingUp = event.key === "ArrowUp";

  if (isGoingDown && currentIndex < allViewDetailsLinks.length - 1) {
    allViewDetailsLinks[currentIndex + 1]?.focus();
  }

  if (isGoingUp && currentIndex > 0) {
    allViewDetailsLinks[currentIndex - 1]?.focus();
  }
};

export const createKeyboardNavigation = () => {
  const handleTabKeyNavigation = e => {
    if (e.key !== "Tab") return;

    const activeElement = document.activeElement;
    navigateWithinOrders(activeElement, e);
  };

  const handleKeyDown = event => {
    handleArrowKeyNavigation(event);
  };

  const setupTabNavigation = () => {
    document.addEventListener("keydown", handleTabKeyNavigation);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleTabKeyNavigation);
      document.removeEventListener("keydown", handleKeyDown);
    };
  };

  return {
    handleKeyDown,
    handleTabKeyNavigation,
    setupTabNavigation
  };
};

